import { Component } from '@angular/core';
import { LocationFormFieldComponent } from './location-form-field.component'; // Path to the original component
import { Coords, Country, LocationObject, Viewport } from '../../../../swagger-api';
import { safelyDetectChanges } from '../../../../common/app.helpers';
import { getStringRepresentationOfLocation } from './location-form-field.helper';
import { FormTypes } from '../../../forms.enum';
import { ValidatorFn, Validators } from '@angular/forms';
import { LocationInputAutocompleteService } from './geocoding/location-input-autocomplete.service';
import { PreparedLocation } from './geocoding/geocoding.helper';

@Component({
  selector: 'app-extend-location-form-field',
  templateUrl: './location-form-field.component.html',
  styleUrls: ['./location-form-field.component.scss'],
  providers: [LocationInputAutocompleteService],
})
export class ExtendLocationFormFieldComponent extends LocationFormFieldComponent {
  protected override setupValidators() {
    if (this.fieldAttribute.backendAttribute.required) {
      this.control.setValidators(Validators.required);
    }
  }

  protected override setupNativeElementValue() {
    const value = this.control.value as LocationObject;
    this.searchElementRef.nativeElement.value = getStringRepresentationOfLocation(value);
  }

  protected override updateValue() {
    if (!this.searchElementRef.nativeElement.value) {
      this.control.patchValue(null);
      this.control.markAsDirty();
      safelyDetectChanges(this.changeDetectorRef);
      return;
    }

    this.setupNativeElementValue();
  }

  protected override updateControlValue(location: LocationObject) {
    this.control.setValue(
      {
        country: {
          alpha2: location.country.alpha2,
          full_name: location.country.full_name,
        } as Country,
        region: location.region,
        subregion: location.subregion,
        province: location.province,
        city: location.city,
        street: location.street,
        center: {
          lat: location.center.lat,
          lon: location.center.lon,
        } as Coords,
      },
      { emitEvent: true },
    );
    this.control.markAsDirty();
  }

  protected override updateViewPortIfNecessary(viewPort: Viewport) {
    this.viewportService.updateViewport(viewPort);
  }

  protected override runAdditionalValidationIfNecessary(preparedLocationComponents: PreparedLocation) {
    const isRequiredStreetName = !(
      this.fieldAttribute.id.includes(FormTypes.PROJECT) || this.fieldAttribute.id.includes(FormTypes.COMMUNITY)
    );
    if (isRequiredStreetName) {
      const streetName: string = preparedLocationComponents.street;
      this.additionalValidation({ streetName });
    }
  }

  private additionalValidation(fields: { streetName?: string }): void {
    if (this.fieldAttribute.backendAttribute.required && fields.streetName === '') {
      this.streetValidator();
    }

    this.control.updateValueAndValidity();
  }

  private streetValidator(): void {
    const streetValidator: ValidatorFn = this.formValidationService.streetValidator();

    const validators: ValidatorFn[] = this.fieldAttribute.backendAttribute.required
      ? [Validators.required, ...[streetValidator]]
      : [streetValidator];

    this.control.setValidators(Validators.compose(validators));
  }
}
